import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Select2ajaxService } from '../select/select2ajax.service';
import { FileService } from '../file/file.service';
import { CLEditorService } from '../html/cleditor.service';
//// kts
import { KtsConstructionClassificationService } from '../../../projects/kts/items/columns/construction-classification/construction-classification.service';
var ColumnService = /** @class */ (function () {
    function ColumnService(s2Service, fileService, cleditorService, 
    //// kts
    constClassService) {
        this.s2Service = s2Service;
        this.fileService = fileService;
        this.cleditorService = cleditorService;
        this.constClassService = constClassService;
        this.refOptions = {};
        this._subject = new BehaviorSubject({});
        this._validSubject = new BehaviorSubject({});
        this._refSubject = new Subject();
    }
    ColumnService.prototype.setInit = function (targetComponents) {
        if (targetComponents === void 0) { targetComponents = []; }
        this.s2Service.setInit(targetComponents);
        this.fileService.setInit(targetComponents);
        this.refOptions = {};
        //// kts
        this.constClassService.setInit(targetComponents);
    };
    ColumnService.prototype.refresh = function (timeout) {
        if (timeout === void 0) { timeout = 0; }
        this.cleditorService.refresh(timeout);
    };
    ColumnService.prototype.addError = function (targetComponents, clear) {
        if (targetComponents === void 0) { targetComponents = []; }
        if (clear === void 0) { clear = false; }
        this._subject.next({ flg: true, targetComponents: targetComponents, clear: clear });
    };
    Object.defineProperty(ColumnService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ColumnService.prototype.addValidationError = function (error, targetComponents) {
        if (targetComponents === void 0) { targetComponents = []; }
        this._validSubject.next({ error: error, targetComponents: targetComponents });
    };
    Object.defineProperty(ColumnService.prototype, "validationObservable", {
        get: function () {
            return this._validSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ColumnService.prototype.reflection = function (targets) {
        var ref = false;
        for (var _i = 0, targets_1 = targets; _i < targets_1.length; _i++) {
            var target = targets_1[_i];
            if (typeof target.targetOption === 'undefined') {
                continue;
            }
            this.setRefOptions(target.targetOption.componentName, target.targetOption.itemKey, target.rec);
            ref = true;
        }
        if (ref) {
            this._refSubject.next(true);
        }
    };
    Object.defineProperty(ColumnService.prototype, "refObservable", {
        get: function () {
            return this._refSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ColumnService.prototype.getRefOptions = function (compName, key) {
        return this.refOptions[compName] && this.refOptions[compName][key] ? this.refOptions[compName][key] : null;
    };
    ColumnService.prototype.setRefOptions = function (compName, key, options) {
        if (typeof this.refOptions[compName] === 'undefined') {
            this.refOptions[compName] = {};
        }
        this.refOptions[compName][key] = options;
    };
    ColumnService.prototype.getSwitchItems = function (col, val, sw) {
        var items = [];
        if (!sw && col.params && col.params.switch) {
            sw = col.params.switch;
        }
        if (!col.items && typeof sw !== 'undefined') {
            var cs = jsonpath.value(sw, '$.case[?(@.value=="' + val + '")]');
            if (cs && cs.items) {
                items = cs.items;
            }
            else {
                if (sw.default && sw.default.items) {
                    items = sw.default.items;
                }
            }
        }
        return items;
    };
    ColumnService.prototype.checkItemVal = function (col, val) {
        if (col.controlType) {
            if (col.controlType === 'file') {
                if (val && !val.match(/(.+\/)(.+\..+)$/)) {
                    return false;
                }
                else if (col.required) {
                    return this.checkVal(val);
                }
                else {
                    return true;
                }
            }
            else if ((col.controlType === 'htmlEditor' || col.controlType === 'cleditor') && val) {
                val = val.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '');
            }
            else if (col.controlType === 'displayTarget') {
                var non_member = (col.params && col.params.non_member && col.params.non_member.key ? col.params.non_member.key : '');
                var member = (col.params && col.params.member && col.params.member.key ? col.params.member.key : '');
                if (non_member && member && (typeof val === 'undefined' || (!val[non_member] && !val[member]))) {
                    return false;
                }
            }
            //// kts
            if (col.controlType === 'constructionClassification') {
                var classification = jsonpath.value(col, '$.params.classification.key');
                var middleClassification = jsonpath.value(col, '$.params.middleClassification.key');
                if (classification && middleClassification && (typeof val === 'undefined' || !val[classification] || !val[middleClassification])) {
                    return false;
                }
            }
            else if (col.controlType === 'department') {
                var departmentKey = jsonpath.value(col, '$.params.department.key');
                if (departmentKey && (typeof val === 'undefined' || !val[departmentKey])) {
                    return false;
                }
            }
        }
        return this.checkVal(val);
    };
    ColumnService.prototype.checkVal = function (val) {
        if ((val instanceof Array && val.length < 1) || typeof val === 'undefined' || val === null || val === '') {
            return false;
        }
        return true;
    };
    ColumnService.prototype.checkRequired = function (col, val) {
        //// kts
        if (col.key && col.required && (col.controlType === 'constructionClassification' || col.controlType === 'department')) {
            return this.checkItemVal(col, val);
        }
        //// ma31
        if (!col || (!col.key && col.controlType !== 'displayTarget') || !col.required) {
            return true;
        }
        return this.checkItemVal(col, val);
    };
    ColumnService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ColumnService.ctorParameters = function () { return [
        { type: Select2ajaxService },
        { type: FileService },
        { type: CLEditorService },
        { type: KtsConstructionClassificationService }
    ]; };
    return ColumnService;
}());
export { ColumnService };
//# sourceMappingURL=column.service.js.map